window.VH = window.VH === undefined ? {} : window.VH;
VH.TomSelect = {
    tsList : {},
    counter : 0,

    setTS : function setTS(index, element) {
        // console.log([index, element]);
        let _t = VH.TomSelect,
            t = $(element),
            id = t.attr('id'),
            tsOptions = {
                plugins:  ['clear_button'],
                render: {
                    option: function (data, escape) {
                        // console.log([data, escape]);
                        return '<div class="' + data.$option.className + '">' + escape(data.text) + '</div>';
                    },
                    item: function (data, escape) {
                        // console.log([data, escape]);
                        return '<div class="' + data.$option.className + '">' + escape(data.text) + '</div>';
                    }
                }
            },
            dataOptions = t.data('ts-options')
        ;

        if (t.hasClass('tomselected')) {
            return;
        }

        if (!id) {
            id = 'uTSId' + (_t.counter++);
            t.attr('id', id);
        }

        if (dataOptions !== undefined) {
            for (let prop in dataOptions) {
                tsOptions[prop] = dataOptions[prop];
            }
        }
        _t.tsList[id] = new TomSelect('#' + id, tsOptions);
        return _t.tsList[id];
    },

    init : function init(selector) {
        let _t = VH.TomSelect;
        selector = selector===undefined ? 'select.uTomSelect' : selector;
        $(selector).each(_t.setTS);
    }
};